import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  raised?: boolean;
  interactive?: boolean;
  pad?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card({ raised, interactive, pad, className, children, ...rest }, ref): JSX.Element {
  const classes = [
    "card",
    raised ? "card--raised" : "",
    interactive ? "card--interactive" : "",
    pad ? "card--pad" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div ref={ref} className={classes} {...rest}>
      {children}
    </div>
  );
});

export interface CardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
}

export function CardHeader({ title, subtitle, action }: CardHeaderProps): JSX.Element {
  return (
    <div className="card__head">
      <div>
        <div className="card__title">{title}</div>
        {subtitle ? <div className="card__sub">{subtitle}</div> : null}
      </div>
      {action ? <div className="row">{action}</div> : null}
    </div>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
  return <div className={["card__body", className ?? ""].filter(Boolean).join(" ")}>{children}</div>;
}
